module.exports = __webpack_public_path__ + "static/media/Email fav.0cd14aef.png";